import React, { useContext, useEffect, useState } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { Triangle } from 'react-loader-spinner';
import { GetData } from "../Api";
import FilterContext from "../Hooks/Context";
import Grid from '../Views/Grid'
import { useTranslation } from "react-i18next";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { addDays, addMinutes, subDays } from "date-fns";
import enUS from "rsuite/locales/en_US";
import zhLocale from "rsuite/locales/zh_CN";

import Dropdown from "../Components/ReportsDropdown";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateTimePicker from "@mui/lab/MobileDateTimePicker";
import DesktopDateTimePicker from "@mui/lab/DesktopDateTimePicker";
import { MultiSelect } from "react-multi-select-component";
import moment from 'moment';
import $ from "jquery";
import html2canvas from "html2canvas";

import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import { CONSTANTS } from '../Api/Constants';
moment.suppressDeprecationWarnings = true;

const DefectDetails = () => {

  const filterQueries = useContext(FilterContext);
  const [currentLanguage, SetCurrentLanguage] = useState();
  const [reportData, SetReportData] = useState();
  const [isReportChanged, SetIsReportChanged] = useState();
  const { t } = useTranslation();
  const [language, SetLanguage] = useState();
  const [startValue, setStartValue] = useState();
  const [endValue, setEndValue] = useState();
  const [selectedOption, SetSelectedOption] = useState();
  const [selected, setSelected] = useState([]);
  const [selectedMachines, SetSelectedMachines] = useState();
  const [loaderVisiblity, SetLoaderVisiblity] = useState(false);
  const [nilData, SetNilData] = useState(false);
  const [startOfTheDay, SetStartOfTheDay] = useState();
  const [endOfTheDay, SetEndOfTheDay] = useState();
  const [updateMultiSelect, SetUpdateMultiSelect] = useState();
  const [machineData, SetMachineData] = useState([]);
  const [searchText, SetSearchText] = useState();
  const [searchSrc, SetSearchSrc] = useState();
  const [multiselect, SetMultiSelect] = useState(false);
  const [conveyorList, SetConveyorList] = useState();
  const [modelList, SetModelList] = useState();
  const [rootCause, SetRootCause] = useState();
  const [references, SetReferences] = useState();
  const [filterReset, SetFilterReset] = useState(false);
  const [toggleLineDropdown, SetToggleLineDropDown] = useState(false);

  const [options, SetOptions] = useState([
    { label: "SPI", value: "spi", title: "SPI" },
    { label: "Pre-AOI", value: "preaoi", title: "Pre-AOI" },
    { label: "Post-AOI", value: "postaoi", title: "Post-AOI" }
  ]);
  const [chineseOptions, SetChineseOptions] = useState([
    { label: "SPI", value: "spi", title: "SPI" },
    { label: "前AOI", value: "preaoi", title: "Pre-AOI" },
    { label: "后AOI", value: "postaoi", title: "Post-AOI" }
  ]);
  const [requestParameters, SetRequestParameters] = useState({
    'factory': '1',
    'line': '1',
    'startTs': '',
    'endTs': '',
    'shift': '',
    'machines': '',
    'shiftData': '1',
    'conveyorList': '1',
    'modelList' : '1',
    'referencesList' : '1',
    'rootCauses' : '1'
  });
  const { i18n } = useTranslation('TargetVsActual');

  const [shiftData, SetShiftData] = useState([
    { id: "1", label: "All Shift" },
    { id: "2", label: "Shift A" },
    { id: "3", label: "Shift B" }
  ]);

  /* Mock data for dropdown */
  const factoryData = [
    { id: "1", label: "Select Factory" },
    { id: "2", label: "All Factories" },
    { id: "3", label: "Flexunion" }
  ];

  const masterLineDropDownData = [
    { id: "1", label: "Select Line" },
    { id: "2", label: "All Lines" },
    { id: "3", label: "Line 2" }
  ];

  const [lineDropdownData, SetLineDropdownData] = useState([
    { id: "1", label: "Select Line" },
    { id: "2", label: "All Lines" },
    { id: "3", label: "Line 2" }
  ]);

  let AllLinesData = [
    { id: "1", label: "All Lines" }
  ];

  let shiftMatchData = {
    "A": "Shift A",
    "B": "Shift B"
  };

  const columns = [
    { dataField: 'factory_name', text: 'Factory', sort: true },
    { dataField: 'line_name', text: 'Line', sort: true },
    { dataField: 'date', text: 'Date', sort: true },
    { dataField: 'conveyor', text: 'Conveyor', sort: true },
    { dataField: 'pf_reason', text: 'PF Reasons', sort: true },
    { dataField: 'model_number', text: 'Model Number', sort: true },
    { dataField: 'pcb_number', text: 'PCB Number', sort: true },
    { dataField: 'side', text: 'Side', sort: true },
    { dataField: 'root_cause', text: 'Root Causes', sort: true },
    { dataField: 'references', text: 'Reference', sort: true }
  ];

  const chineseColumns = [
    { dataField: 'factory_name', text: '工厂', sort: true },
    { dataField: 'line_name', text: '线', sort: true },
    { dataField: 'date', text: '日期和时间', sort: true },
    { dataField: 'conveyor', text: '轨道', sort: true },
    { dataField: 'pf_reason', text: '不良', sort: true },
    { dataField: 'model_number', text: '型号', sort: true },
    { dataField: 'pcb_number', text: '条码', sort: true },
    { dataField: 'side', text: '正反面', sort: true },
    { dataField: 'root_cause', text: '可能根源设备', sort: true },
    { dataField: 'references', text: '参考位', sort: true }
  ];

  const GetReportsData = (startOfTheDay, endOfTheDay, selectedMachines) => {
    if (
      filterQueries &&
      filterQueries.filterRequestQuery !== null &&
      filterQueries.filterRequestQuery !== undefined
    ) {
      GetData(
        `report/defect-detail?startTs=${startOfTheDay}&endTs=${endOfTheDay}&factoryId=1&lineId=1&device=${selectedMachines}&shift=${requestParameters.shift}`
      )
        .then((response) => {
          let updatedData = JSON.parse(JSON.stringify(response.data));
          let conveyorData = [{"id":"1","label":"All Conveyors"}], 
              modelLists = [{"id":"1","label":"All Models"}], 
              referenceList = [{"id":"1","label":"All Reference"}], 
              rootCauseArray = [{"id":"1","label":"All Root Cause"}];
          updatedData.map((item, index) => {
            item.date = moment().utc(item.date).format('MM/DD/YYYY HH:mm:ss');
            item.shift = shiftMatchData[item.shift];
            if (conveyorData.indexOf(item.conveyor) === -1) {
              let conveyorItem = {};
              conveyorItem.id = conveyorData.length + 1;
              conveyorItem.label = item.conveyor;
              let conveyorCounts = conveyorData.filter(obj => obj.label === item.conveyor);
              if (conveyorCounts.length <= 0)
                conveyorData.push(conveyorItem);
            }

            if (modelLists.indexOf(item.model_number) === -1) {
              let modelListItem = {};
              modelListItem.id = modelLists.length + 1;
              modelListItem.label = item.model_number;
              let conveyorCounts = modelLists.filter(obj => obj.label === item.model_number);
              if (conveyorCounts.length <= 0)
                modelLists.push(modelListItem);
            }

            if (referenceList.indexOf(item.references) === -1) {
              let referenceListItem = {};
              referenceListItem.id = referenceList.length + 1;
              referenceListItem.label = item.references;
              let conveyorCounts = referenceList.filter(obj => obj.label === item.references);
              if (conveyorCounts.length <= 0 && item.references !== '')
                referenceList.push(referenceListItem);
            }

            if (rootCauseArray.indexOf(item.root_cause) === -1) {
              let rootCausesListItem = {};
              rootCausesListItem.id = rootCauseArray.length + 1;
              rootCausesListItem.label = item.root_cause;
              let conveyorCounts = rootCauseArray.filter(obj => obj.label === item.root_cause);
              if (conveyorCounts.length <= 0)
                rootCauseArray.push(rootCausesListItem);
            }


          })

          SetConveyorList(conveyorData);
          SetModelList(modelLists);
          SetRootCause(rootCauseArray);
          SetReferences(referenceList);

          SetSearchSrc(updatedData);
          SetReportData(updatedData);
          SetIsReportChanged(true);
          SetLoaderVisiblity(false);
          return response.data;
        })
        .then((data) => {
        })
        .catch((error) => {
          SetNilData(true);
          SetLoaderVisiblity(false);
        });
    }
  };

  useEffect(() => {
    let updatedValue = new Date();

    let sDate = updatedValue;
      sDate.setHours(CONSTANTS.SHIFT.ENDHOUR)
      sDate.setMinutes(CONSTANTS.SHIFT.ENDMIN)
      sDate.setSeconds(CONSTANTS.SHIFT.ENDSEC)
    
    let eDate = addDays(updatedValue, 1);
      eDate.setHours(CONSTANTS.SHIFT.ENDHOUR)
      eDate.setMinutes(CONSTANTS.SHIFT.ENDMIN)
      eDate.setSeconds(CONSTANTS.SHIFT.ENDSEC)

    setStartValue(sDate);
    setEndValue(eDate);
  }, []);

  useEffect(() => {

    if (selected && selected.length >= 1) {
      FormatMultiSelectOptions();
    } else {
      SetMachineData([]);
    }

  }, [selected]);

  useEffect(() => {
    setSelected([]);
   }, [i18n.language]);

  useEffect(() => {

    if(requestParameters.factory.toString() >= '2') {
        SetMultiSelect(false);
    } else {
      SetMultiSelect(true);
    }

  }, [requestParameters]);

  const FormatMultiSelectOptions = () => {

    if (selected && selected.length >= 1)
      SetMachineData([selected[selected.length - 1]]);

    let updatedValue = JSON.parse(JSON.stringify(selected));
    var completedCounts = selected.filter(obj => obj.value === "completedCounts");
    let selectedOptionsi18n = i18n.language === 'en' ? options : chineseOptions;

    selectedOptionsi18n.map((item, index) => {
      item.disabled = false;
    });
    if (completedCounts.length === 1) {
      selectedOptionsi18n.map((item, index) => {
        if (item.value !== "completedCounts")
          item.disabled = true;
        else
          item.disabled = false;
      })
    }

    var otherCounts = selected.filter(obj => obj.value !== "completedCounts");
    if (otherCounts.length >= 1) {
      selectedOptionsi18n.map((item, index) => {
        if (item.value === "completedCounts")
          item.disabled = true;
        else
          item.disabled = false;
      })
    }

    if (i18n.language === 'en') {
      SetOptions(selectedOptionsi18n);
    } else {
      SetChineseOptions(selectedOptionsi18n);
    }
    SetUpdateMultiSelect(!updateMultiSelect);

  }

  const GenerateReport = () => {

    SetLoaderVisiblity(true);
    let startOfTheDay = Math.floor(
      Date.UTC(
        startValue.getFullYear(),
        startValue.getMonth(),
        startValue.getDate(),
        startValue.getHours(),
        startValue.getMinutes(),
        startValue.getSeconds()
      ) / 1000
    );

    let endOfTheDay = Math.floor(
      Date.UTC(
        endValue.getFullYear(),
        endValue.getMonth(),
        endValue.getDate(),
        endValue.getHours(),
        endValue.getMinutes(),
        endValue.getSeconds()
      ) / 1000
    );

    let selectedMachines = "";
    machineData.map((option, index) => {
      if (option.label === "Completed Counts") {
        selectedMachines = selectedMachines + "";
      } else {
        if (selectedMachines === "") {
          selectedMachines = selectedMachines + (option.title).toLowerCase();
        } else {
          selectedMachines = selectedMachines + "," + (option.title).toLowerCase();
        }
      }
    });

    SetSelectedMachines(selectedMachines);
    SetStartOfTheDay(startOfTheDay);
    SetEndOfTheDay(endOfTheDay);
    GetReportsData(startOfTheDay, endOfTheDay, selectedMachines);

  }

  const localeMap = {
    en: enUS,
    zh: zhLocale,
  };

  const SetFilterValue = (label, id, name) => {

    if(name === 'factory') {
      if(label !== 'Select Factory') {
        SetToggleLineDropDown(true);
      } else {
        SetToggleLineDropDown(false);
      }

      if(id === '2') {
        SetLineDropdownData(AllLinesData);
      } else {
        SetLineDropdownData(masterLineDropDownData);
      }
    }

    if (name === 'shift') {
      let shiftData = {
        "1": "",
        "2": "A",
        "3": "B"
      }
      SetRequestParameters(
        {
          ...requestParameters,
          'shift': shiftData[id],
          'shiftData': id,
          'label': label
        });
    } else {
      SetRequestParameters(
        {
          ...requestParameters,
          [name]: id,
          'label': label
        });
    }

  }

  const exportPDF = () => {

    $("#GenerateButton").hide();
    html2canvas($("#filterGroup")[0]).then((canvas) => {
      let canvasImage = canvas.toDataURL(); //image data of canvas
      const unit = "pt";
      const size = "A2"; // Use A1, A2, A3 or A4
      const orientation = "portrait"; // portrait or landscape
      const marginLeft = 40;
      const doc = new jsPDF(orientation, unit, size);
      doc.setFontSize(9);
      const title = `Defect Details Report`;
      let headers;

      headers = [["Factory", "Line", "Date", "Conveyor", "PF Reasons", "Model Number", "PCB Number","Side","Root Causes","Reference"]];
      const data = reportData.map(elt => [elt.factory_name, elt.line_name, elt.date, elt.conveyor, elt.pf_reason, elt.model_number, elt.pcb_number,elt.side, elt.root_cause, elt.references]);
      let content = {
        startY: 110,
        head: headers,
        body: data
      };
      console.log('content - - - - - - - ', content);
      doc.text(title, marginLeft, 40);
      doc.addImage(canvasImage, 'JPEG', 40, 50, 500, 45)
      doc.autoTable(content);
      doc.save(`Defect Details Report`)
      $("#GenerateButton").show();
    });


  }

  const SearchGrid = (item, id, name) => {
    SetFilterValue(item, id, name);
    if(id !== '1') {
      SetFilterReset(true);
      SetSearchText(item);
      var completedCounts = searchSrc.filter(obj => obj.conveyor === item || obj.date === item || obj.factory_id === item || obj.factory_name === item || obj.line_id === item || obj.line_name === item || obj.model_number === item || obj.pcb_number === item || obj.pf_reason === item || obj.program_name === item || obj.references === item || obj.root_cause === item || obj.shift === item || obj.side === item);
      SetReportData(completedCounts);
    } else {
      SetFilterReset(false);
      SetRequestParameters(
        {
          ...requestParameters,
          'conveyorList': '1',
          'modelList' : '1',
          'referencesList' : '1',
          'rootCauses' : '1'
        });
      SetReportData(searchSrc);
    }
  }

  return (
    <div key={isReportChanged}>
      <h4>{t("LT_defect_details")}</h4>
      <div id="filterGroup">
      <div className="filter-container" key={ lineDropdownData.length } >
      <Dropdown
          selectedLanguage={language}
          data={factoryData}
          placeholder={t("LT_select_factory")}
          selectedItem={factoryData[requestParameters.factory - 1]}
          name="factory"
          parentSelector={SetFilterValue}
          width={"140px"}
        />
        { toggleLineDropdown && <Dropdown
          data={lineDropdownData}
          placeholder={t("LT_select_line")}
          selectedItem={lineDropdownData[requestParameters.factory  === '2' ? 0 : requestParameters.line - 1]}
          name="line"
          parentSelector={SetFilterValue}
          width={"90px"}
        /> }

        <LocalizationProvider
          key={language}
          dateAdapter={AdapterDateFns}
          locale={localeMap[currentLanguage]}
        >
          <div className="mobile-only">
            <MobileDateTimePicker
              value={startValue}
              maxDate={new Date()}
              onChange={(newValue) => {
                setStartValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="desktop-only">
            <DesktopDateTimePicker
              value={startValue}
              maxDate={new Date()}
              onChange={(newValue) => {
                setStartValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="mobile-only">
            <MobileDateTimePicker
              minDate={startValue}
              maxDate={addDays(startValue, 1)}
              value={endValue}
              onChange={(newValue) => {
                setEndValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
          <div className="desktop-only">
            <DesktopDateTimePicker
              minDate={startValue}
              maxDate={new Date()}
              value={endValue}
              onChange={(newValue) => {
                setEndValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
        </LocalizationProvider>

        <Dropdown
          data={shiftData}
          placeholder={t("LT_select_line")}
          selectedItem={shiftData[requestParameters.shiftData - 1]}
          name="shift"
          parentSelector={SetFilterValue}
          width={"80px"}
        />
        <div>
          <MultiSelect
            options={i18n.language === 'en' ? options : chineseOptions}
            value={machineData}
            onChange={setSelected}
            labelledBy="Select Machines"
            className="multi-select"
            hasSelectAll={false}
            disabled={ multiselect }
          />
        </div>

        <button className="generate-btn" onClick={GenerateReport} disabled={selected.length >= 1 ? false : true}>
          {t("LT_generate")}
        </button>

      </div>

      {selected && selected.length >= 1 && <div className='report-selected'>{selected.length ? (
        <div>
          <br />
          <ul>
          <li className='selected-machines'>{ t("Selected Machines") }: </li>
            {machineData.map((option, index) =>
              <li key={option.value}>
                {option.label} {index !== machineData.length - 1 ? "," : ""}
              </li>
            )}
          </ul>
        </div>) : ''
      }
      </div>}
      </div>
      <br />
      {nilData || ( reportData && reportData.length) === 0 && <div className='no-data-available'>{t("LT_no_data_available")}</div>}
      {loaderVisiblity && <div className="loader">
        <Triangle arialLabel="loading-indicator" color="#002E5B" width="120" height="120" />
        <span className='loading-span'>{t("LT_loading")}...</span>
      </div>}
      {!nilData && reportData && reportData.length >= 1 && <div className='reports-container' key={filterReset}>
        <div className='reports-container-heading'>
          <div className='report-table-subheading'>{t("LT_defect_details")}</div>
          {conveyorList && <Dropdown
            selectedLanguage={language}
            data={conveyorList}
            placeholder={t("Select Conveyors")}
            selectedItem={conveyorList[filterReset ? requestParameters.conveyorList - 1 : 0]}
            name="conveyorList"
            parentSelector={SearchGrid}
            width={"120px"}
          />}

          {modelList && <Dropdown
            selectedLanguage={language}
            data={modelList}
            placeholder={t("Select Model")}
            selectedItem={modelList[filterReset ? requestParameters.modelList - 1 : 0]}
            parentSelector={SearchGrid}
            name="modelList"
            width={"300px"}
          />}

          {references && <Dropdown
            selectedLanguage={language}
            data={references}
            placeholder={t("Select Reference")}
            selectedItem={references[filterReset ? requestParameters.referencesList - 1 : 0]}
            parentSelector={SearchGrid}
            name="referencesList"
            width={"200px"}
          />}

          {rootCause && <Dropdown
            selectedLanguage={language}
            data={rootCause}
            placeholder={t("Select RootCause")}
            selectedItem={rootCause[filterReset ? requestParameters.rootCauses - 1 : 0]}
            parentSelector={SearchGrid}
            name="rootCauses"
            width={"150px"}
          />}

          <div>
            {t("LT_view")}
            &nbsp;
            <i className="fa fa-file-pdf-o download-icon" onClick={() => exportPDF()} aria-hidden="true"
            ></i>
            <br />
          </div>
        </div>
        <Grid gridData={reportData} gridColumns={i18n.language === 'en' ? columns : chineseColumns} name="Defect Details" enableSearch={true} searchData={searchText} />
      </div>}
    </div>
  );
};

export default DefectDetails;
